import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import { Breadcrumb } from "antd";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useEffect, useState } from "react";
import {
  getCategoryTreeById,
  getCategoryTreeFindId,
  getCategoryById,
} from "../Services";
import { useDispatch } from "react-redux";
import { handleSetIsShowAdvertPreview } from "apps/RealState/ListItems/ClientStates";

const CategoryBreadCrumb = () => {
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);
  const dispatch = useDispatch();
  const data = advertDetails?.data?.data;
  const categoryIds = data?.categoryCombinedKey?.split("_") || [];
  const categoryPath = data?.categoryCombinedValue;

  const navigate = useNavigate();
  const { capitalize } = useCapitalize();
  const [categoryData, setCategoryData] = useState<any>({});
  const [topCategoryId, setTopCategoryId] = useState<any>(null); // Asenkron sonucu tutmak için
  const [breadcrumbCategories, setBreadcrumbCategories] = useState<any[]>([]);


  const parts = categoryPath?.split("_") || [];

  const getCategoryTree = async (categoryId: string) => {
    try {
      const response: any = await getCategoryTreeFindId(categoryId);
      if (response?.data) {
        setCategoryData(response?.data);
      }
    } catch (error) {
      openNotificationWithIcon("default", "Kategori ağacı oluşturulmadı");
    }
  };

  useEffect(() => {
    if (advertDetails.data) {
      getCategoryTree(advertDetails?.data?.data?.categoryId);
    }
  }, [advertDetails.data]);

  useEffect(() => {
  const fetchCategoryChain = async () => {
    let currentCategoryId = data?.category?.topCategoryId;
    const resultArray = [];

    // Üst kategorileri getiriyoruz
    for (let i = 0; i < parts.length && currentCategoryId; i++) {
      try {
        const result = await getCategoryById(currentCategoryId);
        resultArray.unshift(result.data); // üstten ekle
        currentCategoryId = result.data.topCategoryId;
      } catch (error) {
        console.error("getCategoryById error", error);
        break;
      }
    }

    // Şu anki kategori (ilanın kendi kategorisi)
    if (data?.category) {
      resultArray.push(data.category);
    }

    setBreadcrumbCategories(resultArray);
  };

  if (data?.category?.topCategoryId && parts.length > 0) {
    fetchCategoryChain();
  }
}, [data, parts.length]);



  interface Category {
    id: number;
    name: string;
    subCategories?: Category[];
  }


  function findCategoryById(
    categories: Category[],
    categoryId: number
  ): Category | null {
    for (const category of categories) {
      if (category.id === categoryId) {
        return category;
      }
      if (category.subCategories) {
        const found = findCategoryById(category.subCategories, categoryId);
        if (found) return found;
      }
    }
    return null;
  }

  return (
    // <div className="flex items-center gap-1 text-sm font-medium text-gray-700">
    //   {parts.map((part: any, index: any) => (
    //     <div key={index} className="flex items-center gap-1">
    //       <span
    //         className="hover:text-blue-600 hover:cursor-pointer transition-colors"
    //         onClick={async () => {
    //           await dispatch(handleSetIsShowAdvertPreview({ status: false }));
    //           navigate(`/ilan/${part}`);
    //         }}
    //       >
    //         {capitalize(part)}
    //       </span>
    //       {index < parts.length - 1 && (
    //         <span className=" text-gray-400">/</span>
    //       )}
    //     </div>
    //   ))}
    // </div>
    <div className="flex items-center gap-1 text-sm font-medium text-gray-700">
  {breadcrumbCategories.map((cat, index) => (
    <div key={cat.id} className="flex items-center gap-1">
      <span
        className="hover:text-blue-600 hover:cursor-pointer transition-colors"
        onClick={async () => {
          await dispatch(handleSetIsShowAdvertPreview({ status: false }));
          if(data?.category.type === 1){
           navigate(`/ilan/${cat.filterUrl}`);
          }else{
 navigate(`/ilan/${cat.url}`);
          }
         
        }}
      >
        {capitalize(cat.name)}
      </span>
      {index < breadcrumbCategories.length - 1 && (
        <span className=" text-gray-400">/</span>
      )}
    </div>
  ))}
</div>

  );
};

export default CategoryBreadCrumb;
